// Tabs
import {Tutorial} from "@/data/classes/tutorial";
import router from "@/router";
let tutorial = new Tutorial();

export const tabs : any[] = [
    {
        icon: "support",
        key: "general",
        title: "tutorial-form.title",
        type: "single",
        sections: [
            {
                inputs: [
                    {
                        label: 'tutorial-form.published',
                        name: 'input_tutorial_published',
                        type: 'select',
                        required: true,
                        path: "Published",
                        disabled: false,
                        decode: (value: boolean) => {
                            return value?.toString();
                        },
                        encode: (value: string) => {
                            return value === "true";
                        },
                        options: [{
                            key: "true",
                            label: "tutorial-form.published-true",
                            value: "true"
                        },{
                            key: "false",
                            label: "tutorial-form.published-false",
                            value: "false"
                        }],
                        size: 50
                    },
                    {
                        label: 'tutorial-form.language',
                        name: 'input_tutorial_language',
                        type: 'language',
                        required: true,
                        path: "Language",
                        disabled: false,
                        size: 50
                    },
                    {
                        label: 'tutorial-form.type',
                        name: 'input_tutorial_type',
                        type: 'select',
                        required: true,
                        path: "Type",
                        disabled: false,
                        options: [{
                            key: "regular",
                            label: "tutorial-form.type-regular",
                            value: "regular"
                        },{
                            key: "video",
                            label: "tutorial-form.type-video",
                            value: "video"
                        }],
                        size: 100
                    }
                ]
            },
            {
                title: 'tutorial-form.description',
                inputs: [
                    {
                        label: 'tutorial-form.title-short',
                        name: 'input_tutorial_title_short',
                        type: 'text',
                        required: true,
                        path: "TitleShort",
                        size: 100
                    },
                    {
                        label: 'tutorial-form.intro-short',
                        name: 'input_tutorial_intro_short',
                        type: 'textarea',
                        required: true,
                        path: "IntroShort",
                        size: 100
                    }
                ]
            },
            {
                title: 'tutorial-form.content',
                inputs: [
                    {
                        label: 'tutorial-form.title',
                        name: 'input_tutorial_title',
                        type: 'text',
                        required: true,
                        path: "Title",
                        size: 100
                    },
                    {
                        label: 'tutorial-form.subtitle',
                        name: 'input_tutorial_subtitle',
                        type: 'text',
                        required: true,
                        path: "SubTitle",
                        size: 100
                    },
                    {
                        label: "tutorial-form.image-header",
                        name: 'input_tutorial_image_header',
                        type: 'image',
                        required: false,
                        directUpload: true,
                        fileTypes: ["png", "jpg", "jpeg"],
                        maxFileSize: 50,
                        path: "ImageUrl",
                        folder: "tutorials/",
                        urlPath: "ImageUrl",
                        extensionPath: "ImageExtension",
                        filenamePath: "ImageName",
                        widthPath: "ImageWidth",
                        heightPath: "ImageHeight",
                        sizePath: "ImageSize",
                        size: 100
                    }
                ]
            },
            {
                title: 'tutorial-form.tip',
                inputs: [
                    {
                        label: 'tutorial-form.tip-title',
                        name: 'input_tutorial_tip_title',
                        type: 'text',
                        required: false,
                        path: "TipTitle",
                        size: 100
                    },
                    {
                        label: 'tutorial-form.tip-subtitle',
                        name: 'input_tutorial_tip_subtitle',
                        type: 'textarea',
                        required: false,
                        rules: '',
                        path: "TipText",
                        size: 100
                    }
                ]
            },
            {
                title: 'tutorial-form.video-url',
                inputs: [
                    {
                        label: 'tutorial-form.video-url',
                        name: 'input_tutorial_video_url',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "YouTubeUrl",
                        size: 100
                    }
                ]
            },
            {
                title: 'tutorial-form.sorting',
                inputs: [
                    {
                        label: 'tutorial-form.sort-index',
                        name: 'input_tutorial_sort_index',
                        type: 'number',
                        required: true,
                        rules: '',
                        path: "SortIndex",
                        size: 50
                    }
                ]
            },
            {
                title: 'tutorial-form.tags',
                inputs: [
                    {
                        label: 'tutorial-form.tags',
                        name: 'input_tutorial_section_tags',
                        type: 'array',
                        required: false,
                        rules: '',
                        path: "Tags",
                        size: 100
                    }
                ]
            },
        ]
    }
]


export const getData = async () => {
    if (router.currentRoute.params.tutorialId !== "new"){
        await tutorial.get(router.currentRoute.params.tutorialId);
    } else {
        tutorial = new Tutorial();
    }

    return tutorial.toJSON();
}


export const onSubmit = async (formValues: any) => {
    // Set values
    tutorial.set(formValues);

    // Update license
    return tutorial.update();
}
